export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "ID no disponible",
    depo_descripcion: item.depo_descripcion|| "Nombre no disponible",
    sucursal: item.depo_suc?.nombre || "Sucursal no disponible",
    direccion: item.depo_direccion || "Dirección no disponible",
  }));
